import Modal from '@/components/Modal/Modal';
import { WithdrawTab } from './WithdrawTab';
import { SendFriendsTab } from './SendFriendsTab';
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react';
import { useWalletAddress } from '@/features/account-abstraction/hooks/useWalletAddress';
import useWalletBalance from '@/hooks/useWalletBalance';
import config from '@/common/config';
import useGetFriends from '@/services/friends/queries/useGetFriends';
import useGetReferrals from '@/services/referrals/queries/useGetReferrals';
import TabHeader from '@/components/TabHeader/TabHeader';
import DepositTab from '@/features/user-profile/components/DepositTab';
import TransactionsTab from '@/features/user-profile/components/TransactionsTab';
import useIsMobileView from '@/hooks/useIsMobileView';
import { TokensTab } from './TokensTab';

const sendTabs: string[] = ['Deposit', 'Withdraw', 'Transfer', 'Transactions', 'Tokens'];

const SendModalContainer = ({
  open,
  setClose,
  defaultTabIndex = 0,
  defaultTransferId,
}: {
  open: boolean;
  setClose: () => void;
  defaultTabIndex?: number;
  defaultTransferId?: string;
}) => {
  const onClose = () => {
    setClose();
  };
  const { walletAddress } = useWalletAddress();

  const isMobileView = useIsMobileView();

  const { data: friendsData } = useGetFriends();
  const { data: referralsData } = useGetReferrals();

  const { data: usdtBalance } = useWalletBalance(walletAddress, config.contracts.usdt);

  const balance = usdtBalance ? usdtBalance.displayBalance : '-';
  const mergedUsersData = [
    ...(friendsData && Array.isArray(friendsData.data) ? friendsData.data : []),
    ...(referralsData && Array.isArray(referralsData.data) ? referralsData.data : []),
  ];

  return (
    <Modal open={open} setClose={setClose} titleComponent={<Modal.Title onClose={onClose} title="Wallet" />}>
      <TabGroup defaultIndex={defaultTabIndex}>
        <div className="mb-6 shrink-0 overflow-x-auto scrollbar-thin">
          <TabList className="flex w-full">
            {sendTabs.map((tab) => (
              <Tab className="w-full focus:outline-none" key={tab}>
                {({ selected }) => <TabHeader tabLabel={tab} selected={selected} />}
              </Tab>
            ))}
          </TabList>
        </div>
        <TabPanels>
          <TabPanel>
            <DepositTab />
          </TabPanel>
          <TabPanel>
            <WithdrawTab onClose={onClose} balance={balance} />
          </TabPanel>
          <TabPanel>
            <SendFriendsTab
              defaultTransferId={defaultTransferId}
              inputPlaceHolder={'Choose friend or referral' + (isMobileView ? '' : 'from dropdown')}
              users={mergedUsersData}
              friends={friendsData?.data || []}
              onClose={onClose}
              balance={balance}
            />
          </TabPanel>
          <TabPanel>
            <TransactionsTab />
          </TabPanel>
          <TabPanel>
            <TokensTab onClose={onClose} />
          </TabPanel>
        </TabPanels>
      </TabGroup>
    </Modal>
  );
};

export default SendModalContainer;
